/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import axios, { AxiosRequestConfig } from 'axios';
import { CnMessage } from '@sto/cn-ui';
import requestPlus, { requestPlusTypes } from '@sto/request-plus';
import objectPath from 'object-path';
import { showLoading, hideLoading } from './loading';
import requestFile from './appConfig.json';
// import {getCookie} from "@/utils/tools";
import { ENV } from '@/configs/baseUrl';
import Global from '@/utils/global';


export const urlConfigs = {
  daily: 'https://baseinfo-chatbotapi-test.sto.cn/api',
  dev: 'https://baseinfo-chatbotapi-test.sto.cn/api',
  pre: 'https://pre-baseinfo-chatbotapi.sto.cn/api',
  prod: 'https://baseinfo-chatbotapi.sto.cn/api',
}


export const baseUrl = urlConfigs[ENV]


const config: any = {
  axios,
  requestFile,
  setBaseUrl: () => baseUrl,
  beforeRequest: (options) => {
    options.headers = {
      ...Global.fetchHeader,
      ...options.headers,
      robotCode: Global.robotInfo.robotCode,
    }
    if (options.method?.toUpperCase() === 'GET') {
      options.params = (options.data || options.params);
      delete options.data;
    }
    const url = decodeURIComponent(options.url);
    const reg = /\/{(.+?)}/g;
    const matchKey = url.match(reg)?.[0];
    if (matchKey) {
      const idKey = matchKey.replace(/\/|{|}/g, '');
      const data = options?.data || options?.params;
      if (data?.[idKey]) {
        options.url = `${url?.replace(reg, '')}/${data?.[idKey]}`;
        options.data && delete options.data[idKey];
        options.params && delete options.params[idKey];
      } else {
        options.url = `${url?.replace(reg, '')}`;
      }
    }

    return options;
  },
};

export type RequestPlusQuestProps = AxiosRequestConfig & {
    name?: string;
    isFormData?: boolean;
    loading?: boolean;
    isHandleError?: boolean;
    // 强制获取
    getPayload?: boolean;
    /**
     * 模块类型
     */
    modeType?: 'link';
  } & {
    /**
     * 获取原始数据
     */
    originSource?: boolean;
    /**
     * 返回值相关的options
     */
    responseOptions?: responseOptionsProps;
  };

export type responseOptionsProps = {
  /**
   * 是否需要弹出消息
   */
  hasErrMsg?: boolean;
  hasSuccessMsg?: boolean;
  /**
   * 自定义消息
   * @param response
   * @returns
   */
  errMsg?: (response: any) => string;
  successMsg?: (response: any) => string;

  /**
   * 自定义消息路径
   */
  errMsgPath?: string;
  successPath?: string;

  /**
   * 回调
   */
  successCallback?: (response) => void;
  errorCallback?: (response) => void;
} & any;

export const newRequest: any = requestPlus(config);

// 校验
const hasCheck = (response, path, defaultValue) => {
  return objectPath.has(response, path) ? objectPath.get(response, path) : defaultValue;
};

// 请求信息提示
export const responseMessage = (response, responseStatus, options) => {
  const {
    hasErrMsg = true,
    hasSuccessMsg = false,
    errMsg,
    successMsg,
    errMsgPath = 'data.errorMsg',
    successPath = 'data.data',
    ...otherOptions
  } = options;

  const getTitle = (set, path, value = '') =>
    (set && set(response)) || objectPath.get(response, path) || value;
  // 当失败状态，并且配置errMsgFlag发起弹框错误
  !responseStatus &&
    hasErrMsg &&
    CnMessage.error({
      title:
        getTitle(errMsg, errMsgPath) ||
        objectPath.get(response, 'data.message') ||
        objectPath.get(response, 'data.errorMsg') ||
        '请求失败',
      ...otherOptions,
    });
  responseStatus &&
    hasSuccessMsg &&
    CnMessage.success({
      title: getTitle(successMsg, successPath, '请求成功'),
      ...otherOptions,
    });
};

/**
 * 回调
 * @param response
 * @param responseStatus
 * @param options
 */
export const responseCallback = (response, responseStatus, options) => {
  const { successCallback, errorCallback } = options;
  responseStatus && successCallback && successCallback(response);
  !responseStatus && errorCallback && errorCallback(response);
};

export const responseMiddleware = (response, ops: responseOptionsProps) => {
  const options = {
    hasErrMsg: true,
    hasSuccessMsg: false,
    errMsgPath: 'errorMsg',
    successPath: 'data',
    ...ops,
  };

  // 校验返回体是否为blob
  if (response?.data instanceof Blob) {
    // 如果blob返回的json格式，需要进行解构
    if (newRequest.isResponseTypeJson(response)) {
      newRequest.PlugBlobToJson(response, (jsonResponse) => {
        responseMiddleware(jsonResponse, options);
      });
    }
    return true;
  }
  let responseStatus = false;

  // 先进行接口 业务字段装填校验
  const isSuccess = hasCheck(response, 'data.success', true);
  const status = objectPath.get(response, 'status');
  responseStatus = status === 200 && isSuccess;

  // if (objectPath.has(response, 'data.errorCode') || objectPath.has(response, 'data.respCode')) {
  //   responseStatus =
  //     objectPath.get(response, 'data.errorCode') === '200' ||
  //     objectPath.get(response, 'data.respCode') === '000';
  // } else {
  //   // 有这个字段才校验，否则判断data.code也行

  //   const isSuccess = hasCheck(response, 'data.success', true);
  //   const status = objectPath.get(response, 'status');
  //   responseStatus = status === 200 && isSuccess;
  // }
  responseMessage(response, responseStatus, options);
  responseCallback(response, responseStatus, options);
  return responseStatus;
};

/**
 * 检查是否登录
 * @param payload
 */
// const checkLogin = (payload) => {
//   const hasLogin =
//     typeof payload.data === 'string' && payload.data.indexOf('<script>top.location=') > -1;
//   if (hasLogin) {
//     // 去头 去尾
//     const HEADER_STRING = payload.data.replace('<script>top.location=', ' ');
//     const newUrl = HEADER_STRING.replace(';</script>', ' ');
//     try {
//       (top as any).location.href = JSON.parse(newUrl);
//     } catch (e) {
//       // console.log('e', e);
//     }
//     throw new Error('登录过期');
//   }
// };

// const headers: any = {
//   identityId: JSON.parse(localStorage.getItem('userInfo') || '{}').identityId,
//   WebUserToken: SYSTEMCONFIG.GET_STORAGE(),
//   WebUserToken2: SYSTEMCONFIG.GET_STORAGE(),
//   AppId: SYSTEMCONFIG.APPID,
// };

export const R = (options: RequestPlusQuestProps) => {
  const { originSource, responseOptions, ...rest } = options;
  if (options.loading) {
    showLoading()
  }
  return newRequest({
    ...rest,
    // headers,
    withCredentials: true,
  }).then((res) => {
    try {
      hideLoading && hideLoading();
      // checkLogin(res);
      if (originSource) return res;
      if (res.data instanceof Blob) {
        return res.data;
      }
      if (responseMiddleware(res, responseOptions)) {
        return res.data ? res.data.data || res.data : res;
      }
      return false;
    } catch (err) {
      return Promise.reject();
    }
  });
};

export const request = (options: RequestPlusQuestProps) => {
  const { originSource, responseOptions, ...rest } = options;
  if (options.loading !== false) {
    showLoading();
  }

  return newRequest({
    ...rest,
    withCredentials: true,
  }).then((res) => {
    try {
      hideLoading && hideLoading();
      // checkLogin(res);
      if (originSource) return res;
      if(res.code === 'ERR_NETWORK') return { errMessage: '获取失败' };

      if (responseOptions?.hasErrMsg && !res.data.success) {
        CnMessage.warning(
          responseOptions?.errMsgPath && res.data[responseOptions?.errMsgPath]
            ? res.data[responseOptions?.errMsgPath]
            : responseOptions?.errorMsg?.(),
        );
        // CnMessage.warning(
        //   responseOptions?.errorMsg
        //     ? responseOptions?.errorMsg()
        //     : res.data[responseOptions?.errMsgPath],
        // );
      }
      if (responseOptions?.hasSuccessMsg && res.data.success) {
        CnMessage.success(
          responseOptions?.successMsgPath && res.data[responseOptions?.successMsgPath]
            ? res.data[responseOptions?.successMsgPath]
            : responseOptions?.successMsg?.(),
        );
        // CnMessage.success(
        //   responseOptions?.successMsg
        //     ? responseOptions?.successMsg()
        //     : res.data[responseOptions?.successMsgPath],
        // );
      }
      if (res.data instanceof Blob) {
        return res.data;
      }
      return res.data ? res.data : res;
    } catch (err) {
      return Promise.reject();
    }
  });
};
